import { RadioArray } from "controls/radioArray";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Card, Col, Row } from "react-bootstrap";
import ChargeTypeViewModel from "viewModels/eshop/order/components/chargeViewModel";
import { registerView } from "@frui.ts/views";
import { DataTestIds } from "../../../../../data-test-constants";
import { chargeTypeIcon } from "utils/chargeTypeIcon";

const ChargeTypeView: FunctionComponent<{
  vm: ChargeTypeViewModel;
}> = observer(({ vm }) => {
  const chargeOrderChargeItem = vm.chargeOrderChargeItem;
  const labelContent = (
    <Card.Body className="p-2" data-testid={DataTestIds.chargeCardPrice(vm.chargeType.validFor)}>
      <Row className="m-0">
        <Col className="p-0 col-auto">
          <img
            style={{ width: "6rem", height: "6rem" }}
            src={chargeTypeIcon(vm.chargeType.validFor, vm.isCSLocale)}
            alt={vm.description}
          />
        </Col>
        <Col className="d-flex align-items-center mt-0 pt-lg-1 pt-sm-1 pt-xl-0 pl-xl-1 pl-xxl-2">
          <Row className="flex-sm-column align-items-center">
            <Col xs={12} sm={6} xl={12}>
              <h5 className="m-0 text-nowrap align-self-center">{vm.description}</h5>
            </Col>
            <Col xs={12} sm={6} xl={12}>
              <span className="text-sm-right m-0 text-left text-nowrap text-xl-left">{vm.price}</span>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card.Body>
  );

  const isSelected = chargeOrderChargeItem.chargeTypeId === vm.chargeType.id;

  const radioId = `${vm.chargeTypeCode}-${vm.batchIndex ?? 0}`;
  return (
    <Card
      className={"mt-3 charge-view " + (isSelected ? " border-success" : "") + (vm.error ? " border-danger" : "")}
      style={{
        backgroundColor: isSelected ? "rgba(1, 177, 99, 0.1)" : "transparent",
      }}>
      <RadioArray
        custom
        label={labelContent}
        className={"charge-type-select d-flex align-items-center label-stretch pl-0"}
        name={"chargeType"}
        target={chargeOrderChargeItem}
        property="chargeTypeId"
        isNumeric={false}
        id={radioId}
        option={vm.chargeType.id}
        isInvalid={!!vm.error}
      />
    </Card>
  );
});

registerView(ChargeTypeView, ChargeTypeViewModel);
